var loader = function () {

	var publicMethods = {};

	var dataAttribute = 'data-loader';

	publicMethods.show = function (data) {

		loader.hide();

		var dataIsObject = data && typeof data === 'object';

		title = dataIsObject && 'title' in data ? data.title : 'Please wait';
		message = dataIsObject && 'message' in data ? data.message : 'You will be able to continue soon';

		var loaderElement = document.createElement('div');
		loaderElement.setAttribute('class', 'loader');
		loaderElement.setAttribute(dataAttribute, '');
		loaderElement.setAttribute('role', 'alert');

		loaderElement.innerHTML =
			'<div class="loader__inner">' +
			'<div class="loader__inner-inner">' +
			'<div class="loader__spinner"></div>' +
			'<div class="loader__content">' +
			'<p class="loader__title">' + title + '</p>' +
			'<p class="loader__message">' + message + '</p>' +
			'</div> ' +
			'</div>' +
			'</div> ';

		document.body.appendChild(loaderElement);

	};

	publicMethods.hide = function () {

		const loaderElement = document.querySelector('[' + dataAttribute + ']');
		if (!loaderElement) return;

		loaderElement.remove();

	};

	return publicMethods;

}();
